import { render, staticRenderFns } from "./TotalEmployee.vue?vue&type=template&id=0208af0b&scoped=true&"
import script from "./TotalEmployee.vue?vue&type=script&lang=js&"
export * from "./TotalEmployee.vue?vue&type=script&lang=js&"
import style0 from "./TotalEmployee.vue?vue&type=style&index=0&id=0208af0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0208af0b",
  null
  
)

export default component.exports